import { Plus } from 'lucide-react';
import { useState } from 'react';
import { useLogManualFood } from '@/api/logs/logs';
import { DishPicker } from '@/components/dish-picker';
import { Button } from '@/components/ui/button';

/**
 * "Add manually" — the dish picker wired to log what it returns.
 *
 * Collapsed by default: the main way to log a meal is messaging the bot, and
 * this is the correction path, so it should not compete with the day's list.
 */
export function ManualAdd({ onAdded }: { onAdded: () => Promise<void> | void }) {
  const [open, setOpen] = useState(false);

  const log = useLogManualFood({
    mutation: {
      onSuccess: async () => {
        setOpen(false);
        await onAdded();
      },
    },
  });

  if (!open) {
    return (
      <Button variant="subtle" size="lg" onClick={() => setOpen(true)}>
        <Plus className="size-4" aria-hidden />
        เพิ่มเอง
      </Button>
    );
  }

  return (
    <div className="space-y-3 rounded-card border border-border-subtle bg-surface-muted p-4">
      <DishPicker busy={log.isPending} onPick={(pick) => log.mutate({ data: pick })} />

      <Button variant="ghost" size="lg" onClick={() => setOpen(false)}>
        ยกเลิก
      </Button>
    </div>
  );
}
